import { render, staticRenderFns } from "./a-link.vue?vue&type=template&id=3ec7f488"
import script from "./a-link.vue?vue&type=script&lang=js"
export * from "./a-link.vue?vue&type=script&lang=js"
import style0 from "./a-link.vue?vue&type=style&index=0&id=3ec7f488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports